import React, { useEffect, useState, useCallback, useRef } from 'react';
import { joinDHMSToSeconds, splitSecondsToDHMS } from '../../utils/conditionWait';
import './styles.css';

function digitsOnly(raw) {
  return String(raw).replace(/\D/g, '');
}

const UNITS = [
  { key: 'd', label: 'd', title: 'Days' },
  { key: 'h', label: 'h', title: 'Hours' },
  { key: 'm', label: 'm', title: 'Minutes' },
  { key: 's', label: 's', title: 'Seconds' },
];

/**
 * Custom wait: days / hours / minutes / seconds. Empty = no wait.
 */
const WaitDurationFields = ({ seconds, onChange, disabled = false }) => {
  const [parts, setParts] = useState(() => splitSecondsToDHMS(seconds));
  const partsRef = useRef(parts);

  useEffect(() => {
    const next = splitSecondsToDHMS(seconds);
    setParts(next);
    partsRef.current = next;
  }, [seconds]);

  const commit = useCallback((next) => {
    onChange?.(joinDHMSToSeconds(next));
  }, [onChange]);

  const handleChange = (key, raw) => {
    const next = { ...partsRef.current, [key]: digitsOnly(raw) };
    partsRef.current = next;
    setParts(next);
  };

  return (
    <div
      className="conditions-modal__wait-fields"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      {UNITS.map(({ key, label, title }) => (
        <label key={key} className="conditions-modal__wait-unit" title={title}>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="off"
            spellCheck={false}
            disabled={disabled}
            className="conditions-modal__wait-input"
            value={parts[key]}
            placeholder="-"
            aria-label={title}
            onChange={(e) => handleChange(key, e.target.value)}
            onFocus={(e) => e.target.select()}
            onBlur={() => commit(partsRef.current)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.target.blur();
            }}
          />
          <span className="conditions-modal__wait-unit-label">{label}</span>
        </label>
      ))}
    </div>
  );
};

export default WaitDurationFields;
